import { IconChevronDown, IconChevronUp } from '@tabler/icons-react'

import PropTypes from 'prop-types'

const DetailsArrow = ({ visible }) => {
  return !visible ? <IconChevronDown color='grey' size={20} /> : <IconChevronUp color='grey' size={20} />
}

DetailsArrow.propTypes = {
  visible: PropTypes.bool.isRequired,
}

export default DetailsArrow
